// TotalSeven — cart enhancements (no libraries): Save for later + promo code.
(function () {
  var KEY = 'ts_saved_for_later_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ── Saved for later ─────────────────────────────────────────────────────────
  function renderSaved() {
    var root = document.getElementById('ts-saved-root');
    if (!root) return;
    var list = read();
    if (!list.length) {
      root.innerHTML = '';
      root.hidden = true;
      return;
    }
    root.hidden = false;
    var rows = list.map(function (it) {
      return (
        '<li class="ts-saved__item">' +
          '<a class="ts-saved__media" href="' + esc(it.url) + '">' +
            (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" width="70">' : '') +
          '</a>' +
          '<div class="ts-saved__info">' +
            '<a class="ts-saved__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            (it.price ? '<span class="ts-saved__price">' + esc(it.price) + '</span>' : '') +
            '<div class="ts-saved__actions">' +
              '<button type="button" class="ts-saved__move" data-id="' + esc(it.id) + '">Move to cart</button>' +
              '<button type="button" class="ts-saved__remove" data-id="' + esc(it.id) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
    root.innerHTML =
      '<h2 class="ts-saved__heading">Saved for later (' + list.length + ')</h2>' +
      '<ul class="ts-saved__list list-unstyled">' + rows + '</ul>';
  }

  function saveForLater(btn) {
    var item = {
      id: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url'),
      price: btn.getAttribute('data-price')
    };
    if (!item.id) return;
    var list = read();
    if (!list.some(function (x) { return x.id === item.id; })) list.push(item);
    write(list);
    btn.disabled = true;
    // Remove the line from the active cart, then refresh so totals + items update.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.id, quantity: 0 })
    }).then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  function moveToCart(id) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) { window.alert('Sorry — this item is no longer available.'); return; }
      write(read().filter(function (x) { return x.id !== id; }));
      window.location.reload();
    }).catch(function () {});
  }

  function removeSaved(id) {
    write(read().filter(function (x) { return x.id !== id; }));
    renderSaved();
    markWishlist();
  }

  // ── Wishlist (Save for later from product cards + product page) ───────────────
  var WISHLIST_SEL = '.ts-wishlist, .ts-wishlist--inline';

  function setButtonState(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function toggleWishlist(btn) {
    var item = {
      id: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url'),
      price: btn.getAttribute('data-price')
    };
    if (!item.id) return;
    var list = read();
    var exists = list.some(function (x) { return x.id === item.id; });
    list = exists ? list.filter(function (x) { return x.id !== item.id; }) : list.concat([item]);
    write(list);
    // Reflect the new state on every button for this variant (card + PDP).
    var els = document.querySelectorAll(WISHLIST_SEL);
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-variant-id') === item.id) setButtonState(els[i], !exists);
    }
    renderSaved();
  }

  function markWishlist() {
    var ids = {};
    read().forEach(function (x) { ids[x.id] = true; });
    var els = document.querySelectorAll(WISHLIST_SEL);
    for (var i = 0; i < els.length; i++) {
      setButtonState(els[i], !!ids[els[i].getAttribute('data-variant-id')]);
    }
  }

  // ── Promo code ──────────────────────────────────────────────────────────────
  // Applies via the discount URL (covers code + automatic discounts); the code
  // then shows in cart.cart_level_discount_applications on the reloaded cart.
  function applyPromo(form) {
    var input = form.querySelector('.ts-promo__input');
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  document.addEventListener('click', function (e) {
    var wish = e.target.closest(WISHLIST_SEL);
    if (wish) { e.preventDefault(); toggleWishlist(wish); return; }
    var save = e.target.closest('.ts-save-later');
    if (save) { e.preventDefault(); saveForLater(save); return; }
    var mv = e.target.closest('.ts-saved__move');
    if (mv) { e.preventDefault(); moveToCart(mv.getAttribute('data-id')); return; }
    var rm = e.target.closest('.ts-saved__remove');
    if (rm) { e.preventDefault(); removeSaved(rm.getAttribute('data-id')); return; }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ts-promo__form');
    if (form) { e.preventDefault(); applyPromo(form); }
  });

  // ── Gift message — save to the cart note (lands on the order admin) + counter ──
  // Handles multiple fields (cart page + add-to-cart popup); counter scoped per field.
  function initGiftNote() {
    var fields = document.querySelectorAll('[data-ts-note]');
    if (!fields.length) return;
    Array.prototype.forEach.call(fields, function (ta) {
      var wrap = ta.closest('.ts-gift, .ts-gift-note') || document;
      var counter = wrap.querySelector('[data-ts-note-count]');
      var max = parseInt(ta.getAttribute('maxlength') || '250', 10);
      var labelEl = wrap.querySelector('[data-ts-note-label]');
      var defaultLabel = labelEl ? labelEl.textContent : '';
      var addedLabel = (labelEl && labelEl.getAttribute('data-label-added')) || 'Gift message added ✓';
      var isCartField = !!ta.closest('.ts-gift');
      var saveTimer;
      function updateCount() { if (counter) counter.textContent = ta.value.length + ' / ' + max; }
      function updateConfirm() {
        var has = ta.value.trim().length > 0;
        if (labelEl) {
          labelEl.textContent = has ? addedLabel : defaultLabel;
          labelEl.classList.toggle('is-added', has);
        }
        if (isCartField) {
          var c = document.querySelector('[data-ts-gift-confirm]');
          if (c) c.hidden = !has;
        }
      }
      function save() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).catch(function () {});
      }
      ta.addEventListener('input', function () {
        updateCount();
        updateConfirm();
        clearTimeout(saveTimer);
        saveTimer = setTimeout(save, 600);
      });
      ta.addEventListener('blur', save);
      // Stop the note's change from bubbling to <cart-items>, which would treat it
      // as a quantity change and show "increments of undefined".
      ta.addEventListener('change', function (e) { e.stopPropagation(); });
      updateCount();
      updateConfirm();
    });
  }

  // ── Popup checkout: ALWAYS go via GET /checkout (never the native POST /cart) ──
  // On this store the native POST /cart from the notification makes mobile Safari
  // download a "cart" file instead of redirecting. GET /checkout redirects cleanly.
  // If a gift note was typed, save it first, then navigate.
  function initPopupCheckout() {
    var form = document.getElementById('cart-notification-form');
    if (!form) return;
    var going = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (going) return;
      going = true;
      var ta = form.querySelector('[data-ts-note]');
      function go() { window.location.href = '/checkout'; }
      if (ta && ta.value.trim()) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).then(go).catch(go);
      } else {
        go();
      }
    });
  }

  function init() { renderSaved(); markWishlist(); initGiftNote(); initPopupCheckout(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
